/*
 * Copyright (c) 2018. CPP, Inc. All rights reserved.
 * Also protected by Patent Pending: 15/916,593
 */
import { GatewayDest, GatewayProvider } from 'react-gateway'
import { Provider } from 'unstated'
import React from 'react'

import Layout from 'components/Layout'
import Sumerian from 'compositions/Sumerian'

export const wrapRootElement = ({ element }) => {
  return (
    <Provider>
      <GatewayProvider>{element}</GatewayProvider>
    </Provider>
  )
}

export const wrapPageElement = ({ element, props }) => {
  let className
  if (props.location.pathname.includes('docs') || props.location.pathname.includes('photos')) {
    className = 'grid docsGrid'
  } else {
    className = 'grid modelGrid'
  }

  return (
    <Layout {...props}>
      <main className={className}>
        {element}
        <Sumerian className='viewerRegion' />
      </main>
      <GatewayDest className="z-0" name="modal" />
    </Layout>
  )
}

//region gatsby-browser API methods
/*
  disableCorePrefetching
  onClientEntry
  onInitialClientRender
  onPreRouteUpdate
  onPrefetchPathname
  onRouteUpdate
  onRouteUpdateDelayed
  onServiceWorkerActive
  onServiceWorkerInstalled
  onServiceWorkerRedundant
  onServiceWorkerUpdateFound
  registerServiceWorker
  replaceComponentRenderer
  shouldUpdateScroll
  wrapPageElement
  wrapRootElement
 */
//endregion
